import Vue from 'vue';
import App from './App.vue';
import VueGtag from 'vue-gtag';
import router from './router';
import '@/assets/scss/styles.scss';
import '@/assets/materialize-css/sass/materialize.scss';
import '@/assets/materialize-css/dist/js/materialize';
import axios from 'axios';

Vue.prototype.$http = axios

Vue.config.productionTip = false;

Vue.use(VueGtag, {
  config: {
      id: 'GTM-WMCDQNH',
      params: {
          send_page_view: false
      }
  }
}, router);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
